import { produce } from "immer";
import {
  GET_NEXT_OF_KIN,
  GET_NEXT_OF_KIN_SUCCESS,
  GET_NEXT_OF_KIN_FAILURE,
  SAVE_NEXT_OF_KIN,
  SAVE_NEXT_OF_KIN_SUCCESS,
  SAVE_NEXT_OF_KIN_FAILURE,
  // other
  FETCH_OTHER_CONTACTS,
  FETCH_OTHER_CONTACTS_SUCCESS,
  FETCH_OTHER_CONTACTS_FAILURE,
  ADD_OTHER_CONTACT,
  ADD_OTHER_CONTACT_SUCCESS,
  ADD_OTHER_CONTACT_FAILURE,
  EDIT_OTHER_CONTACT,
  EDIT_OTHER_CONTACT_SUCCESS,
  EDIT_OTHER_CONTACT_FAILURE,
  DELETE_OTHER_CONTACT,
  DELETE_OTHER_CONTACT_SUCCESS,
  DELETE_OTHER_CONTACT_FAILURE,
  REMOVE_CONTACT,
  REMOVE_CONTACT_SUCCESS,
  REMOVE_CONTACT_FAILURE,
  TOGGLE_OTHER_KIN_MODAL,
  SEARCH_CONTACTS,
  SEARCH_CONTACTS_SUCCESS,
  SEARCH_CONTACTS_FAILURE,
  GET_CONTACT_SUGGESTIONS,
  GET_CONTACT_SUGGESTIONS_SUCCESS,
  GET_CONTACT_SUGGESTIONS_FAILURE,
  SEND_FAMILY_INVITE,
  SEND_FAMILY_INVITE_SUCCESS,
  SEND_FAMILY_INVITE_FAILURE,
  RESEND_FAMILY_INVITE,
  RESEND_FAMILY_INVITE_SUCCESS,
  RESEND_FAMILY_INVITE_FAILURE,
  REVOKE_FAMILY_ACCESS,
  REVOKE_FAMILY_ACCESS_SUCCESS,
  REVOKE_FAMILY_ACCESS_FAILURE,
  TOGGLE_FAMILY_INVITE_MODAL,
  FETCH_FAMILY_ACCESS,
  FETCH_FAMILY_ACCESS_SUCCESS,
  FETCH_FAMILY_ACCESS_FAILURE,
  FETCH_FAMILY_MODULE_PERMISSIONS,
  FETCH_FAMILY_MODULE_PERMISSIONS_FAILURE,
  FETCH_FAMILY_MODULE_PERMISSIONS_SUCCESS,
  SAVE_FAMILY_MODULE_OVERRIDES,
  SAVE_FAMILY_MODULE_OVERRIDES_FAILURE,
  SAVE_FAMILY_MODULE_OVERRIDES_SUCCESS,
} from "./constants";

export const initialState = {
  isFetchingKins: false,
  primaryContact: {},
  secondaryContact: {},
  otherContacts: {},
  isSubmitting: false,
  isDeleting: false,
  isRemovingContact: false,
  otherKinModal: { open: false },
  familyInviteModal: { open: false },
  isFamilyInviteSubmitting: false,
  familyAccessByContactId: {},
  isFetchingFamilyAccess: false,
  familyModulePermissionsByContactId: {},
  isSavingFamilyModuleOverrides: false,
  searchContactsList: [],
  isSearchingContacts: false,
  contactSuggestions: [],
  isFetchingContactSuggestions: false,
};

const ResidentNetworkReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case GET_NEXT_OF_KIN:
        draft.isFetchingKins = true;
        break;
      case GET_NEXT_OF_KIN_SUCCESS:
        draft.isFetchingKins = false;
        draft.primaryContact = action.payload.primaryContact;
        draft.secondaryContact = action.payload.secondaryContact;
        break;
      case GET_NEXT_OF_KIN_FAILURE:
        draft.isFetchingKins = false;
        break;
      case SAVE_NEXT_OF_KIN:
        draft.isFetchingKins = true;
        break;
      case SAVE_NEXT_OF_KIN_SUCCESS:
        draft.isFetchingKins = false;
        break;
      case SAVE_NEXT_OF_KIN_FAILURE:
        draft.isFetchingKins = false;
        break;
      case FETCH_OTHER_CONTACTS:
        draft.isFetchingOtherContacts = true;
        break;
      case FETCH_OTHER_CONTACTS_SUCCESS:
        draft.isFetchingOtherContacts = false;
        // If loading more pages (page > 1), append data to existing data
        if (
          action.payload?.current_page > 1 &&
          draft.otherContacts?.data &&
          Array.isArray(draft.otherContacts.data) &&
          Array.isArray(action.payload.data)
        ) {
          draft.otherContacts = {
            ...action.payload,
            data: [...draft.otherContacts.data, ...action.payload.data],
          };
        } else {
          // First page or initial load - replace data
          draft.otherContacts = action.payload;
        }
        break;
      case FETCH_OTHER_CONTACTS_FAILURE:
        draft.isFetchingOtherContacts = false;
        break;
      case ADD_OTHER_CONTACT:
        draft.isSubmitting = true;
        break;
      case ADD_OTHER_CONTACT_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_OTHER_CONTACT_FAILURE:
        draft.isSubmitting = false;
        break;
      case EDIT_OTHER_CONTACT:
        draft.isSubmitting = true;
        break;
      case EDIT_OTHER_CONTACT_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_OTHER_CONTACT_FAILURE:
        draft.isSubmitting = false;
        break;
      case DELETE_OTHER_CONTACT:
        draft.isDeleting = true;
        break;
      case DELETE_OTHER_CONTACT_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_OTHER_CONTACT_FAILURE:
        draft.isDeleting = false;
        break;
      case REMOVE_CONTACT:
        draft.isRemovingContact = true;
        break;
      case REMOVE_CONTACT_SUCCESS: {
        draft.isRemovingContact = false;
        const contactId = action.payload?.contact_id;
        if (contactId && action.payload?.deleted) {
          delete draft.familyAccessByContactId[contactId];
        } else if (contactId && action.payload?.access) {
          draft.familyAccessByContactId[contactId] = action.payload.access;
        }
        break;
      }
      case REMOVE_CONTACT_FAILURE:
        draft.isRemovingContact = false;
        break;
      case TOGGLE_OTHER_KIN_MODAL:
        draft.otherKinModal = action.payload;
        break;
      case SEARCH_CONTACTS:
        draft.isSearchingContacts = true;
        draft.searchContactsList = [];
        break;
      case SEARCH_CONTACTS_SUCCESS:
        draft.isSearchingContacts = false;
        // Extract data array from paginated response, or use payload directly if it's already an array
        draft.searchContactsList = Array.isArray(action.payload)
          ? action.payload
          : (action.payload?.data ?? []);
        break;
      case SEARCH_CONTACTS_FAILURE:
        draft.isSearchingContacts = false;
        draft.searchContactsList = [];
        break;
      case GET_CONTACT_SUGGESTIONS:
        draft.isFetchingContactSuggestions = true;
        draft.contactSuggestions = [];
        break;
      case GET_CONTACT_SUGGESTIONS_SUCCESS:
        draft.isFetchingContactSuggestions = false;
        draft.contactSuggestions = action.payload;
        break;
      case GET_CONTACT_SUGGESTIONS_FAILURE:
        draft.isFetchingContactSuggestions = false;
        draft.contactSuggestions = [];
        break;
      case TOGGLE_FAMILY_INVITE_MODAL:
        draft.familyInviteModal = action.payload;
        break;
      case FETCH_FAMILY_ACCESS:
        draft.isFetchingFamilyAccess = true;
        break;
      case FETCH_FAMILY_ACCESS_SUCCESS: {
        draft.isFetchingFamilyAccess = false;
        const entries = Array.isArray(action.payload)
          ? action.payload
          : action.payload
            ? [action.payload]
            : [];
        entries.forEach((entry) => {
          const id = entry?.contact_id;
          if (id) draft.familyAccessByContactId[id] = entry;
        });
        break;
      }
      case FETCH_FAMILY_ACCESS_FAILURE:
        draft.isFetchingFamilyAccess = false;
        break;
      case FETCH_FAMILY_MODULE_PERMISSIONS:
        draft.isFetchingFamilyAccess = true;
        break;
      case FETCH_FAMILY_MODULE_PERMISSIONS_SUCCESS:
      case SAVE_FAMILY_MODULE_OVERRIDES_SUCCESS: {
        draft.isFetchingFamilyAccess = false;
        draft.isSavingFamilyModuleOverrides = false;
        const contactId = action.payload?.contact_id;
        if (contactId) {
          draft.familyModulePermissionsByContactId[contactId] = action.payload;
        }
        break;
      }
      case FETCH_FAMILY_MODULE_PERMISSIONS_FAILURE:
        draft.isFetchingFamilyAccess = false;
        break;
      case SAVE_FAMILY_MODULE_OVERRIDES:
        draft.isSavingFamilyModuleOverrides = true;
        break;
      case SAVE_FAMILY_MODULE_OVERRIDES_FAILURE:
        draft.isSavingFamilyModuleOverrides = false;
        break;
      case SEND_FAMILY_INVITE:
      case RESEND_FAMILY_INVITE:
      case REVOKE_FAMILY_ACCESS:
        draft.isFamilyInviteSubmitting = true;
        break;
      case SEND_FAMILY_INVITE_SUCCESS:
      case RESEND_FAMILY_INVITE_SUCCESS: {
        draft.isFamilyInviteSubmitting = false;
        // Invite response includes expires_at / status — merge a provisional
        // status until the dedicated family-access refetch lands.
        const data = action.payload;
        const id = data?.contact_id;
        if (id) {
          draft.familyAccessByContactId[id] = {
            ...(draft.familyAccessByContactId[id] || {}),
            contact_id: id,
            family_app_enabled: data.family_app_enabled ?? true,
            family_app_role:
              data.role ?? draft.familyAccessByContactId[id]?.family_app_role,
            invite_status: "pending",
            invite_expires_at: data.expires_at ?? null,
            access_status: data.status ?? "pending",
            access_role: data.role,
          };
        }
        break;
      }
      case REVOKE_FAMILY_ACCESS_SUCCESS: {
        draft.isFamilyInviteSubmitting = false;
        const data = action.payload;
        const id = data?.contact_id;
        if (id) {
          draft.familyAccessByContactId[id] = data;
        }
        break;
      }
      case SEND_FAMILY_INVITE_FAILURE:
      case RESEND_FAMILY_INVITE_FAILURE:
      case REVOKE_FAMILY_ACCESS_FAILURE:
        draft.isFamilyInviteSubmitting = false;
        break;
      default:
        return state;
    }
  });

export default ResidentNetworkReducer;
